import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

export const Sad = ({ color }) => (
  <SentimentVeryDissatisfiedIcon fontSize="large" sx={{ color }} />
);
